// extracted by mini-css-extract-plugin
export default {"panel":"QhJEzhZ5WlZYJ56","header":"zZCogGrfpyp5sfC","title":"zFQRqPGd1EHRuis","years":"AWw8X1zQDf9VfMR","year":"a1gXj2js5tWscws","selected":"a0S6FSjbmUufn4X"};